//Constante utilisée dans toute l'application
//Role admin
//Nombre de lignes dans un tableau
export const ROLE_ASSEMBLEE_GENERALE = 'Assemblée Générale';
export const ROLE_BUREAU_SYNDICAL = "Bureau Syndical et Conseil d'Administration";
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_BASIC = 'ROLE_BASIC';
export const ROLE_PRESIDENT = 'ROLE_PRESIDENT';
//Message générique en cas d'erreur
export const ERROR_MESSAGE_GENERIC = 'Une erreur est survenue : Merci de contacter votre administrateur';
//Message perte connexion
export const ERROR_MESSAGE_NO_NETWORK = "Oups... Vous n'avez plus de connexion internet";
//Message timeout
export const ERROR_MESSAGE_TIMEOUT = 'Le serveur met trop de temps a repondre. Merci de reessayer dans un instant';
//Http 404
export const HTTP_CODE_NOT_FOUND = 404;
//Http 409
export const HTTP_CONFLICT = 409;
//Http 400
export const HTTP_BAD_REQUEST = 400;
//Http 403
export const HTTP_ACCESS_DENIED = 403;
//Erreur perte réseau
export const HTTP_CODE_BROKEN_NETWORK = 'ERR_NETWORK';
//Erreur timeout
export const HTTP_CODE_TIMEOUT = 'ECONNABORTED';
